const pointHistoryData = [
    {
      id: 1,
      logoUrl: 'https://example.com/starbucks-logo.png',
      description: 'Starbucks Purchase',
      points: 500,
      date: '2024-08-27'
    },
    {
      id: 2,
      logoUrl: 'https://example.com/tims-logo.png',
      description: 'Tim Hortons Purchase',
      points: 300,
      date: '2024-08-27'
    },
    {
      id: 3,
      logoUrl: 'https://example.com/amazon-logo.png',
      description: 'Amazon Purchase',
      points: 1000,
      date: '2024-08-26'
    },
    {
      id: 4,
      logoUrl: 'https://example.com/starbucks-logo.png',
      description: 'Starbucks Purchase',
      points: 200,
      date: '2024-08-15'
    },
  ];
  
  export default pointHistoryData;
  